module.exports = __webpack_public_path__ + "static/media/moose.379c27e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/moose.png
// module id = 41
// module chunks = 0